import SolicitudesImage from "./solicitud-bold.png";
import NuevaSolcicitud from "./nueva-solicitud.png";
import PersonalInformation from "./datos-personales.png";
import PersonalInformationBlack from "./datos-personales-black.png";
import Direction from "./dirección.png";
import Pricing from "./precios.png";
import PricingBlack from "./precios-black.png";
import TermsCondition from "./terminos-condiciones.png";
import TermsConditionBlack from "./terminos-condiciones-black.png";
import Settings from "./settings.png";
import NuevaSolcicitudWhiteImage from "./nueva-solicitud-white.png";
import ConfiguracionImage from "./settings.png";
import ItemMenuBlueImage from "./item_menu_azul.png";
import FilterIconImage from "./filter_icon.png";
import ItemMenuGreenImage from "./item_menu_verde.png";
import ItemMenuRedImage from "./item_menu_rojo.png";
import ItemMenuBlackImage from "./item_menu_negro.png";
import ItemMenuOrangeImage from "./item_menu_naranja.png";
import AddSigner from "./agregarfirmante.png";
import SolicitudNueva from "./solicitud-agregar.png";
import SolicitudEnviada from "./solicitud-enviada.png";
import SolicitudRecibida from "./solicitud-recibida.png";
import SolicitudNuevaWhite from "./solicitud-agregar-white.png";
import Reloj from "./reloj.png";
import Revisado from "./revisado.png";
import ConservacionMensajeImage from "./conservacion-mensajes.png";
import EstampadoTiempoImage from "./estampado-tiempo.png";
import Check from "./done.png";
import Cancel from "./cancel.png";
import PaymentProcess from "./payment-process.png";
import PaymentProcessBlack from "./payment-process-black.png";
import Resume from "./resume.png";
import ResumeBlack from "./resume-black.png";
import OpenPay from "./openpay_color.png";
import Warning from "./warning.png";
import IconUlLogin from "./login_ul_icon.png";
import ImgBackCardOne from "./fondo1.png";
import ImgBackCardTwo from "./fondo2.png";
import ImgBackCardThree from "./fondo3.png";
import ImgBackCardFour from "./fondo4.png";
import ImgBackCardFive from "./fondo5.png";
import ImgBackCardSix from "./fondo6.png";
import LogoGovoLegal from "../../logos/logo_govo.legal.jpg";
import QueriesValidationsImage from "./queries&validations.png";
import PhoneValidation from "./phone-validation.png";
import PhoneValidationBlack from "./phone-validation-black.png";
import Documents from "./documents.png";
import InformationReliable from "./definition.png";
import KeyCerDownload from "./key&cer.png";
import PDFView from "./pdfView.png";
import PersonalData from "./personalData.png";
import OnboardingSignaturePdfDark from "./onboarding_signature_pdf_dark.png";
import SignRequestByVolumeStepOneIcon from "./SignRequestByVolumeStepOneIcon.png";
import SignRequestByVolumeStepTwoIcon from "./SignRequestByVolumeStepTwoIcon.png";
import SignRequestByVolumeStepThreeIcon from "./SignRequestByVolumeStepThreeIcon.png";
import SignRequestByVolumeStepFourIcon from "./SignRequestByVolumeStepFourIcon.png";
import SignRequestByVolumeStepFiveIcon from "./SignRequestByVolumeStepFiveIcon.png";
import newProfileIcon from "./icon_usuario.svg";
import newHelpIcon from "./icon_ayuda.svg";
import newAnadirIcon from "./icon_anadir.png";
import newAnadirIconForButton from "./icon_agregar_btn.png";
import iconAdd from "./btn-add.png";
import PlusBlue from "./plus_blue.png";
import newConfigurationIcon from "./icon_configuracion.svg";
import newCerrarSesionIcon from "./logoCerrarSesion.png";
import newConsultayValidacionesIcon from "./logoConsultaYvalidaciones.png";
import newInboxIcon from "./logoInbox.png";
import newSolicitudDeFirmaIcon from "./logoSolicitudDeFirma.png";
import newLogoPrincipal from "./logoPrincipal.png";
import newAyudaIconAzul from "./iconAyudaAzul.png";
import SignDigitalAvanced from "./firmaDigitalAvanzada.png";
import SignDigitalAutograph from "./firmaAutografaDigitalBase.png";
import ResumeNews from "./resume-news.png";
import search from "./search.png";
import assign from "./assign.png";
import bussiness from "./handshake.png";
import disable from "./disable.png";
import detail from "./detail.png";
import arrowRight from "./arrowRight.png";
import arrowDropDown from "./arrowDropDown.png";
import activeUserAdministration from "./checkmark.png";
import inactiveUserAdministration from "./cancel.png";
import profileIconDefault from "./profile-default.png";
import documentQuestionary from "./documentRead.png";
import documentNotQuestionary from "./documentNot.png";
import seeDetailQuestionnaire from "./verDetalle.png";
import adminQuestionQuestionnaire from "./adminPregunta.png";
import searchIcon from "./searchIcon.png";
import iconoFirma1 from "./iconoFirma1.svg";
import iconTemplateSet from "./icon_template_set.svg";
import iconTemplateUnset from "./icon_template_unset.svg";
import businessIconDefault from "./icon_empresas.svg";
import phoneIcon from "./footer_contact_whatsapp_v2.svg";
import webIcon from "./Web_footer.svg";
import acercaDeGovo from "./footer_govolegal.gif";
import acercaDeGovo240 from "./footer_gif_govo240.gif";
import AvisoPrivacidad from "./avisoprivacidad.svg";
import ContratoArrendamiento from "./contratoarrendamiento.svg";
import ContratoCompraVenta from "./contratocontraventa.svg";
import ContratoLaboral from "./contratolaboral.svg";
import ContratoMutuo from "./contratomutuo.svg";
import ContratoNDA from "./contratoNDA.svg";
import ContratoServicios from "./contratoservicios.svg";
import ContratoSuministros from "./contratosuministro.svg";
import Contratos from "./Contrato.svg";
import Cuestionarios from "./cuestionarios.svg";
import TemplatesImage from "./templates.svg";
import notificationIcon from "./icon_notificacion.svg";
import notificationSmallIcon from "./icon_notificacion_small.svg";
import urgentNotificationIcon from "./icon_urgente_small.svg";
import CargarDocumento from "./cargar.svg";
import DescargarDocumento from "./descarga.svg";
import EditarDocumento from "./editar.svg";
import EliminarDocumento from "./eliminar.svg";
import GenerarContrato from "./generarcontrato.svg";
import TemplateAdministration from "./templates-admin.svg";
import NewContract from "./nuevo_contrato.svg";
import ContractAdministration from "./gestion_contratos.svg";
import QuestionnaireAdministration from "./cuestionario-gestion.svg";
import FilterIcon from "./icon_filtro.svg";
import REPSEIcon from "./icon_REPSE.svg";
import HelpDeskIcon from "./icon_mesadetrabajo.svg";
import ContractIcon from "./icon_altacontratante.svg";
import ContractBlueIcon from "./icon_contrato_azul.svg";
import TrashGridIcon from './icon_botebasura24px.svg';
import TrashIcon from './icon_botebasura18px.svg';
import ArrowBtnMobile from './flecha_mobil_14px.svg';
import ProviderREPSE from "./icon_REPSEproveedor[1506].svg";
import AltaContratanteInbox from "./icon_inbox_altacontratante.svg";
import EjercicioCaligraficoInbox from "./icon_inbox_ejerciciocaligrafico.svg";
import NegociacionInbox from "./icon_inbox_negociacion.svg";
import RepseInbox from "./icon_inbox_REPSE.svg";
import SolicitudContratoInbox from "./icon_inbox_solicitudcontrato.svg";
import ValidacionInbox from "./icon_inbox_validacion.svg";
import DocumentsRequest from "./documentsRequest.png"
import CardViewIcon from './cardView.svg';
import ListViewIcon from './listView.svg';
import AlertsDoc from './alerts.png';
import EditDoc from './edit-doc.svg';
import PrintDoc from './print-doc.png';
import DowloadDoc from './download-doc.svg';
import SendDoc from './send-doc.png';
import ShareDoc from './share-doc.png';
import DeleteDoc from './delete-doc.svg';
import VersionDoc from './version-doc.png';
import AlertsVault from "./alertsVault.svg";
import EditVault from "./editVault.svg"
import PrintVault from "./printVault.png";
import DownloadVault from "./download_vault.svg";
import DeleteVault from "./delete_vault.svg";
import ShareVault from "./share_vault.svg";
import SendVault from "./send_vault.svg";
import VersionVault from "./version_vault.svg";
import LogoGovoLegalLogin from "./LogoGovoLegalBcotrs.png";

export {
  LogoGovoLegal,
  SolicitudesImage,
  NuevaSolcicitud,
  PersonalInformation,
  Direction,
  Pricing,
  TermsCondition,
  Settings,
  NuevaSolcicitudWhiteImage,
  ConfiguracionImage,
  ItemMenuBlueImage,
  ItemMenuGreenImage,
  ItemMenuRedImage,
  ItemMenuBlackImage,
  ItemMenuOrangeImage,
  AddSigner,
  SolicitudNueva,
  SolicitudEnviada,
  SolicitudRecibida,
  SolicitudNuevaWhite,
  Reloj,
  Revisado,
  ConservacionMensajeImage,
  EstampadoTiempoImage,
  Check,
  Cancel,
  PaymentProcess,
  Resume,
  OpenPay,
  IconUlLogin,
  Warning,
  PhoneValidation,
  ImgBackCardOne,
  ImgBackCardTwo,
  ImgBackCardThree,
  ImgBackCardFour,
  ImgBackCardFive,
  ImgBackCardSix,
  FilterIconImage,
  QueriesValidationsImage,
  Documents,
  InformationReliable,
  KeyCerDownload,
  PDFView,
  PersonalData,
  OnboardingSignaturePdfDark,
  SignRequestByVolumeStepOneIcon,
  SignRequestByVolumeStepTwoIcon,
  SignRequestByVolumeStepThreeIcon,
  SignRequestByVolumeStepFourIcon,
  SignRequestByVolumeStepFiveIcon,
  newHelpIcon,
  newProfileIcon,
  newAnadirIcon,
  newAnadirIconForButton,
  PlusBlue,
  PersonalInformationBlack,
  PhoneValidationBlack,
  PricingBlack,
  TermsConditionBlack,
  PaymentProcessBlack,
  ResumeBlack,
  newConfigurationIcon,
  newCerrarSesionIcon,
  newConsultayValidacionesIcon,
  newInboxIcon,
  newLogoPrincipal,
  newSolicitudDeFirmaIcon,
  iconAdd,
  SignDigitalAutograph,
  SignDigitalAvanced,
  newAyudaIconAzul,
  ResumeNews,
  search,
  assign,
  bussiness,
  disable,
  detail,
  arrowRight,
  arrowDropDown,
  activeUserAdministration,
  inactiveUserAdministration,
  profileIconDefault,
  documentNotQuestionary,
  documentQuestionary,
  seeDetailQuestionnaire,
  adminQuestionQuestionnaire,
  searchIcon,
  iconoFirma1,
  iconTemplateSet,
  iconTemplateUnset,
  businessIconDefault,
  phoneIcon,
  webIcon,
  acercaDeGovo,
  acercaDeGovo240,
  AvisoPrivacidad,
  ContratoArrendamiento,
  ContratoCompraVenta,
  ContratoLaboral,
  ContratoMutuo,
  ContratoNDA,
  ContratoServicios,
  ContratoSuministros,
  Contratos,
  notificationIcon,
  urgentNotificationIcon,
  CargarDocumento,
  DescargarDocumento,
  EditarDocumento,
  EliminarDocumento,
  GenerarContrato,
  TemplateAdministration,
  NewContract,
  ContractAdministration,
  QuestionnaireAdministration,
  notificationSmallIcon,
  FilterIcon,
  ContractIcon,
  HelpDeskIcon,
  REPSEIcon,
  ContractBlueIcon,
  TrashGridIcon,
  TrashIcon,
  ArrowBtnMobile,
  ProviderREPSE,
  EjercicioCaligraficoInbox,
  ValidacionInbox,
  SolicitudContratoInbox,
  AltaContratanteInbox,
  NegociacionInbox,
  RepseInbox,
  DocumentsRequest,
  CardViewIcon,
  ListViewIcon,
  AlertsDoc,
  EditDoc,
  PrintDoc,
  DowloadDoc,
  SendDoc,
  ShareDoc,
  DeleteDoc,
  VersionDoc,
  AlertsVault,
  EditVault,
  PrintVault,
  DownloadVault,
  DeleteVault,
  ShareVault,
  SendVault,
  VersionVault,
  LogoGovoLegalLogin
};
